import { render, staticRenderFns } from "./ApplicantApplicationPage.vue?vue&type=template&id=26d61b1a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d61b1a')) {
      api.createRecord('26d61b1a', component.options)
    } else {
      api.reload('26d61b1a', component.options)
    }
    module.hot.accept("./ApplicantApplicationPage.vue?vue&type=template&id=26d61b1a&", function () {
      api.rerender('26d61b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/Application/ApplicantApplicationPage.vue"
export default component.exports